import { Translation } from './translation';

export const it: Translation = {
  common: {
    apply: 'Applicare',
    type: 'Tipo',
    showLess: 'Mostrare meno',
    showMore: 'Mostrare di più',
    map: 'Mappa',
    list: 'Lista',
    results: '{count} risultati',
    continue: 'Avanti',
    back: 'Indietro',
    currency: {
      short: 'CHF',
      price: `CHF {price}.–`,
      pricePerMonth: `CHF {price}.– / mese`,
      pricePerSquareMeter: `CHF {price}.–/m<sup>2</sup>`,
    },
    details: "Detagli",
  },
  mapPrivacy: {
    text: `
      Per poter visualizzare la mappa del fornitore terzo Google Maps,
      abbiamo bisogno del tuo consenso all'uso dei cookies.
    `,
    button: `Gestire i cookie`,
  },
  filters: {
    common: {
      reset: 'Ripristinare',
      resetAll: 'Ripristinare tutto',
      deleteAll: 'Cancellare tutti',
      filter: 'Filtro',
      additionalFilters: 'Altri filtri',
      showResults: 'Visualizzare i risultati',
      showXResults: 'Visualizzare {count} risultati',
      modifySearch: 'Personalizzare la ricerca',
      in: 'a',
      title_rent: {
        none: 'Affittare immobili',
        house: 'Case in affitto',
        flat: 'Appartamenti in affitto',
        commercial: 'Oggetti commerciali in affitto',
      },
      title_buy: {
        none: 'Acquistare immobili',
        house: 'Case in vendita',
        flat: 'Appartamenti in vendita',
        land: 'Terreni in vendita',
        income: 'Oggetti a reddito in vendita',
        commercial: 'Oggetti commerciali in vendita',
      },
    },
    search: {
      label: 'Cantone, località, CAP, ID, ...',
      noResults: 'Nessun risultato, verifichi di avere scritto correttamente.',
    },
    contractType: {
      buy: 'Acquistare',
      rent: 'Affittare',
    },
    category: {
      main: {
        label: 'Categoria',
        all: 'Tutti',
        house: 'Casa',
        apartment: 'Appartamento',
        estate: 'Terreno',
        incomeProperty: 'Oggetto a reddito',
        commercial: 'Commercio',
      },
      sub: {
        businessHouse: 'Immobile commerciale',
        garageParking: 'Parcheggio/garage',
        commercialResidentialBuilding: 'Edificio residenziale e commerciale',
        office: 'Ufficio',
        shop: 'Negozio',
        warehouse: 'Deposito',
        factory: 'Fabbrica',
        hotel: 'Albergo',
        restaurant: 'Ristorante',
        practice: 'Studio medico',
        multiFamilyHouse: 'Casa plurifamiliare',
        buildingLand: 'Terreno',
        agriculturalLand: 'Terreno agricolo',
        industrialLand: 'Terreno industriale e commerciale',
        atticFlat: 'Attico',
        roofFlat: 'Appartamento ultimo piano',
        maisonette: 'Duplex',
        studio: 'Studio',
        terraceFlat: 'Appartamento a terrazza',
        loft: 'Loft',
        gardenFlat: 'Padiglione',
        floorFlat: 'Appartamento',
        holidayFlat: 'Appartamento di vacanza',
        furnishedFlat: 'Appartamento ammobiliato',
        oneFamilyHouse: 'Casa unifamiliare',
        midTerraceHouse: 'Casa a schiera',
        endTerraceHouse: 'Casa a schiera angolo',
        rustico: 'Rustico',
        semidetachedHouse: 'Casa bifamiliare',
        terraceHouse: 'Casa a terrazza',
        farmhouse: 'Fattoria',
        mansion: 'Villa',
        holidayHouse: 'Casa vacanza',
        countryHouse: 'Casa di campagna',
        twoFamilyHouse: 'Casa bifamiliare',
        chalet: 'Chalet',
      },
    },
    price: {
      label: 'Prezzo',
    },
    roomCount: {
      label: 'Locali',
      to: 'a',
    },
    livingSpace: {
      label: 'Superficie abitabile',
    },
    propertySpace: {
      label: 'Superficie del terreno',
    },
    usageSpace: {
      label: 'Area utilizzabile',
    },
    sort: {
      label: 'Filtrare',
      newest: 'Ultimi mobili',
      lowestPrice: 'Prezzo crescente',
      highestPrice: 'Prezzo decrescente',
    },
    rateOfReturn: {
      label: 'rendimento lordo',
    },
    units: {
      label: 'unità',
    },
  },
  regionSearch: {
    city: 'Città',
    village: 'Località',
    county: 'Distretto',
    suburb: 'Quartiere',
    state: 'Cantone',
  },
  noResults: {
    title: 'Nessun risultato',
    text: `
      Salvi la sua ricerca e riceverà una notifica degli immobili più recenti corrispondenti ai suoi criteri.
    `,
  },
  searchSubscription: {
    setup: 'Creare un abbonamento di ricerca',
    save: 'Abbonati alla ricerca',
    overlay: {
      title: 'Abbonamento di ricerca',
      text: `
        Saremo lieti di informarla tramite e-mail non appena
        avremo un immobile che soddisfa le sue esigenze.
      `,
      showResults: 'Visualizzare i risulti della ricerca',
      changeFilter: {
        desktop: {
          part1: 'È possibile modificare i criteri nei',
          button: 'filtri',
          part2: ' ',
        },
        mobile: {
          button: 'Modifica criteri di ricerca',
        },
      },
    },
    stepper_title: {
      desktop: {
        step1: 'Impostare i criteri di ricerca',
        step2: 'Impostare i criteri di ricerca',
        step3: "Completare l'abbonamento di ricerca",
        step_final: 'Abbonamento di ricerca salvato',
      },
      mobile: {
        step1: 'Impostare i criteri di ricerca',
        step2: "Completare l'abbonamento di ricerca",
        step_final: 'Abbonamento di ricerca salvato',
      },
    },
    search: {
      label: 'Cantone, località, CAP, ...',
    },
    location: 'Luogo',
    andRadius: 'e raggio',
    yourDetails: 'I suoi dati',
    yourSearchCriteria: 'I suoi criteri di ricerca',
    toObjectSearch: 'Alla ricerca dell’immobile',
    cookieMessage: {
      description: `
        Per poter visualizzare il formulario di contatto, si prega di accettare i cookie per la pubblicità mirata.
      `,
      button: `Gestire i cookie`,
    },
    form: {
      firstName: 'Nome',
      firstNameRequired: 'Il nome è obbligatorio.',
      lastName: 'Cognome',
      lastNameRequired: 'Il cognome è obbligatorio.',
      email: 'E-Mail',
      emailRequired: "L'e-mail è obbligatorio.",
      receiveNewsletter: 'Iscriversi alla newsletter ImmoSky',
      newsletterHint: 'Può revocare la sua iscrizione in qualsiasi momento.',
      acceptPrivacyHint: `
        Con la presente accetti le <a target="_blank" href="/it/cgc/">condizioni generali</a> e la <a target="_blank" href="/it/privacy/">politica sulla privacy</a> di ImmoSky.
      `,
      thirdPartyHint: `
      I suoi dati non saranno trasmessi a terzi.
      La nostra <a target="_blank" href="/it/privacy/">politica sulla privacy è disponibile qui</a>.<br>
      Questo sito è protetto da
        <a target="_blank" href="https://www.google.com/recaptcha/about/">reCAPTCHA</a> e da <a target="_blank" href="https://policies.google.com/privacy">Google Privacy</a>
        Si applicano la politica sulla privacy e le condizioni di utilizzo.
      `,
    },
    successMessage: {
      title: 'Abbonamento di ricerca impostato',
      paragraph1: `
      A breve riceverà un link di conferma tramite e-mail.
      `,
      paragraph2: `
      Non appena avrà dato conferma tramite il link, riceverà regolarmente le e-mail con l’offerta di immobili in linea con le sue richieste.
      `,
    },
  },
  similarObjects: {
    title: 'Immobili simili in prossimità',
    xResults: '{count} risultati',
    modifySearch: {
      text: `
        Modifica la ricerca <br>
        per vedere più risultati.
      `,
      button: 'Adattare la ricerca',
    },
  },
  realEstateObject: {
    sold: 'Venduto',
    priceOnRequest: 'Prezzo su richiesta',
    reserved: 'Riservato',
    topOffer: 'Oggetto top',
    virtualTour: 'Visita virtuale',
  },
  agentOverview: {
    agents: 'Agente immobiliare',
    director: 'Gestione',
    location: 'Posizione',
    agentImagePlaceholderAlt: 'Spazio riservato all\'immagine dell\'agenzia immobiliare',
    region: "Regione",
    properties: "Immobili",
    regions: {
      ch: {
        zh: 'Zurigo',
        fr: 'Friburgo',
        vd: 'Vaud',
        ge: 'Ginevra',
        ne: 'Neuchâtel',
        ju: 'Giura',
        be: 'Berna',
        vs: 'Vallese',
        ti: 'Ticino',
        ur: 'Uri',
        ow: 'Obwaldo',
        nw: 'Nidwaldo',
        lu: 'Lucerna',
        bl: 'Basilea Campagna',
        bs: 'Basilea Città',
        so: 'Soletta',
        ag: 'Argovia',
        zg: 'Zugo',
        gl: 'Glarona',
        gr: 'Grigioni',
        sz: 'Svitto',
        sh: 'Sciaffusa',
        tg: 'Turgovia',
        sg: 'San Gallo',
        ar: 'Appenzell Esterno',
        ai: 'Appenzell Interno',
      },
    }
  }
};
